(function (root) {
  'use strict';

  var OFFER = 'kar98-gifts-unlock-20260827';
  var DEAGLE = 45908710391987;
  var MYSTERY = 45908710457523;
  var CLUB = 45597242949811;
  var GIFT_MINIMUMS = {};
  GIFT_MINIMUMS[String(DEAGLE)] = 2;
  GIFT_MINIMUMS[String(MYSTERY)] = 3;
  var SERVICE_HANDLES = {
    'blaster-club-membership': true,
    'shipping-protection': true,
    'giftwrap': true,
    'blaster-gift-card': true
  };

  function properties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function quantity(item) {
    var value = Number(item && item.quantity);
    return isFinite(value) && value > 0 ? Math.floor(value) : 0;
  }

  function variantId(item) {
    return Number(item && (item.variant_id || item.id)) || 0;
  }

  function bundleToken(item) {
    return String(properties(item)._gbk98_bundle || '').trim();
  }

  function isExactGift(item) {
    return !!GIFT_MINIMUMS[String(variantId(item))];
  }

  function isOfferLine(item, role) {
    var props = properties(item);
    return props._gbk98_offer === OFFER && props._gbk98_role === role;
  }

  function isServiceItem(item) {
    var handle = String(item && (item.handle || item.product_handle) || '').toLowerCase();
    return variantId(item) === CLUB || !!SERVICE_HANDLES[handle];
  }

  function planCartRepairs(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var paidByBundle = {};
    var realProductQuantity = 0;
    var updates = {};
    var seenGifts = {};

    items.forEach(function (item) {
      var token = bundleToken(item);
      if (token && isOfferLine(item, 'paid')) {
        paidByBundle[token] = (paidByBundle[token] || 0) + quantity(item);
      }
      if (!isExactGift(item) && !isServiceItem(item)) {
        realProductQuantity += quantity(item);
      }
    });

    items.forEach(function (item) {
      var key = String(item && item.key || '');
      var id = variantId(item);
      var token = bundleToken(item);

      if (isExactGift(item)) {
        var required = GIFT_MINIMUMS[String(id)];
        var valid = !!key && !!token && isOfferLine(item, 'gift') && (paidByBundle[token] || 0) >= required;
        var giftIdentity = token + '|' + id;
        if (!valid || seenGifts[giftIdentity]) {
          if (key) updates[key] = 0;
          return;
        }
        seenGifts[giftIdentity] = true;
        if (quantity(item) !== 1) updates[key] = 1;
        return;
      }

      if (id === CLUB && isOfferLine(item, 'membership') && realProductQuantity < 1 && key) {
        updates[key] = 0;
      }
    });

    return {
      updates: updates,
      changed: Object.keys(updates).length > 0,
      paidByBundle: paidByBundle,
      realProductQuantity: realProductQuantity
    };
  }

  function readJson(fetcher, url, options) {
    return fetcher(url, options || {}).then(function (response) {
      if (!response || !response.ok) throw new Error('gbk98-cart-guard-' + url + '-' + (response && response.status));
      return response.json();
    });
  }

  function reconcileOnce(fetcher, pathname, sections) {
    return readJson(fetcher, '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (cart) {
      var plan = planCartRepairs(cart);
      if (!plan.changed) return { changed: false, cart: cart, updates: {} };
      var payload = {
        updates: plan.updates,
        sections: sections || ['cart-drawer', 'cart-icon-bubble'],
        sections_url: pathname || '/cart'
      };
      return readJson(fetcher, '/cart/update.js?kaching_bundles=true', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (data) {
        return { changed: true, data: data, updates: plan.updates };
      });
    });
  }

  /* The server-side Gift Eligibility Guard validation (checkout rule) rejects any
     cart mutation whose RESULT leaves a gift below its paid threshold. A plain
     theme quantity-decrease on a paid bundle line would therefore 422 and strand
     the customer. This planner rewrites such a mutation into ONE atomic
     /cart/update.js that applies the requested change AND drops the now-invalid
     gifts together, so the resulting state is valid and the gift disappears in the
     same paint. Returns null (= pass the request through untouched) on anything
     it does not fully understand. */
  function planMutationAugment(cart, url, bodyText) {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (!/\/cart\/(change|update)\.js/.test(String(url || ''))) return null;
    var hasExactGift = cart.items.some(isExactGift);
    if (!hasExactGift) return null;
    var body;
    try { body = JSON.parse(String(bodyText || '')); } catch (error) { return null; }
    if (!body || typeof body !== 'object') return null;

    var requested = {};
    if (/\/cart\/change\.js/.test(String(url))) {
      if (!('quantity' in body)) return null;
      var quantityValue = Number(body.quantity);
      if (!isFinite(quantityValue) || quantityValue < 0) return null;
      var target = null;
      if (body.line !== undefined) {
        var index = Number(body.line);
        if (!isFinite(index)) return null;
        target = cart.items[index - 1] || null;
      } else if (body.id !== undefined) {
        var idText = String(body.id);
        if (idText.indexOf(':') >= 0) {
          target = cart.items.filter(function (item) { return String(item.key) === idText; })[0] || null;
        } else {
          var idNumber = Number(idText);
          target = cart.items.filter(function (item) { return variantId(item) === idNumber; })[0] || null;
        }
      }
      if (!target || !target.key) return null;
      requested[String(target.key)] = quantityValue;
    } else {
      if (!body.updates || typeof body.updates !== 'object' || Array.isArray(body.updates)) return null;
      for (var updateKey in body.updates) {
        var updateQuantity = Number(body.updates[updateKey]);
        if (!isFinite(updateQuantity) || updateQuantity < 0) return null;
        var keyText = String(updateKey);
        var line = null;
        if (keyText.indexOf(':') >= 0) {
          line = cart.items.filter(function (item) { return String(item.key) === keyText; })[0] || null;
        } else {
          var variantNumber = Number(keyText);
          line = cart.items.filter(function (item) { return variantId(item) === variantNumber; })[0] || null;
        }
        if (!line || !line.key) return null;
        requested[String(line.key)] = updateQuantity;
      }
    }

    var prospective = [];
    cart.items.forEach(function (item) {
      var key = String(item.key || '');
      var nextQuantity = key in requested ? requested[key] : quantity(item);
      if (nextQuantity > 0) {
        prospective.push({
          key: key,
          quantity: nextQuantity,
          variant_id: variantId(item),
          handle: item.handle || item.product_handle,
          properties: properties(item)
        });
      }
    });
    var repair = planCartRepairs({ items: prospective });
    if (!repair.changed) return null;

    var updates = {};
    for (var requestedKey in requested) updates[requestedKey] = requested[requestedKey];
    for (var repairKey in repair.updates) updates[repairKey] = repair.updates[repairKey];
    return {
      updates: updates,
      sections: body.sections,
      sections_url: body.sections_url
    };
  }

  root.GBK98CartGuard = {
    planCartRepairs: planCartRepairs,
    planMutationAugment: planMutationAugment,
    reconcileOnce: reconcileOnce
  };

  if (!root.document || !root.fetch || root.__gbk98CartGuardInit) return;
  root.__gbk98CartGuardInit = true;

  var document = root.document;
  var timer = null;
  var busy = false;
  var rerun = false;
  var retries = 0;
  var observers = [];
  var CART_EVENTS = ['cart:refresh', 'cart:updated', 'cart:change', 'cart:added'];

  /* JSON-template cart sections have dynamic ids (template--*__cart-items); the
     request key must come from each wrapper's data-id, never the literal filename. */
  function cartPageSectionId(domId) {
    var el = document.getElementById(domId);
    return (el && el.getAttribute && el.getAttribute('data-id')) || null;
  }

  function sectionList() {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var itemsId = cartPageSectionId('main-cart-items');
    var footerId = cartPageSectionId('main-cart-footer');
    if (itemsId) sections.push(itemsId);
    if (footerId) sections.push(footerId);
    return sections;
  }

  function sectionDocument(html) {
    return new root.DOMParser().parseFromString(html, 'text/html');
  }

  function sectionSource(html, selector) {
    if (!html) return null;
    return sectionDocument(html).querySelector(selector);
  }

  /* Shrine collapses .drawer__header/.cart-drawer__body/.drawer__footer to height 0
     whenever <cart-drawer> carries is-empty; a stale root class is the white-panel
     mechanism, so the root class must always match the repaired item_count. */
  function setRootEmptyState(empty) {
    var drawerRoot = document.querySelector('cart-drawer');
    if (drawerRoot && drawerRoot.classList) drawerRoot.classList.toggle('is-empty', empty);
    var inner = drawerRoot && drawerRoot.querySelector ? drawerRoot.querySelector('.drawer__inner') : null;
    if (!empty && inner && inner.classList) inner.classList.remove('is-empty');
    var cartRoot = document.querySelector('cart-items');
    if (cartRoot && cartRoot.classList) cartRoot.classList.toggle('is-empty', empty);
  }

  function renderSections(data) {
    var sections = data && data.sections || null;
    if (!sections) return;
    var empty = !!data && data.item_count === 0;
    var drawerHtml = sections['cart-drawer'];
    var swapped = false;
    /* Theme-native repaint: swap the whole .drawer__inner contents (header count,
       items, footer totals — and for an emptied cart the drawer__inner-empty block
       plus disabled footer all come re-rendered). The overlay and the cart-drawer
       root with its listeners stay untouched; custom elements re-upgrade on insert
       (live-proven on the add flow). Items-only swap remains the fallback. */
    var innerSource = sectionSource(drawerHtml, '.drawer__inner');
    var innerTarget = document.querySelector('cart-drawer .drawer__inner');
    if (innerSource && innerTarget) {
      innerTarget.innerHTML = innerSource.innerHTML;
      swapped = true;
    }
    if (!swapped) {
      var itemsSource = sectionSource(drawerHtml, 'cart-drawer-items');
      var itemsTarget = document.querySelector('cart-drawer-items');
      if (itemsSource && itemsTarget) itemsTarget.replaceWith(itemsSource);
    }
    setRootEmptyState(empty);
    var iconHtml = sections['cart-icon-bubble'];
    var iconTarget = document.querySelector('#cart-icon-bubble');
    if (iconHtml && iconTarget) {
      /* The rendered section has no #cart-icon-bubble wrapper (that div lives in the
         header); fall back to the .shopify-section wrapper's contents. */
      var iconSource = sectionSource(iconHtml, '#cart-icon-bubble') || sectionSource(iconHtml, '.shopify-section');
      if (iconSource) iconTarget.innerHTML = iconSource.innerHTML;
    }
    var itemsId = cartPageSectionId('main-cart-items');
    if (itemsId) {
      var pageSource = sectionSource(sections[itemsId], '#main-cart-items');
      var pageTarget = document.getElementById('main-cart-items');
      if (pageSource && pageTarget) pageTarget.replaceWith(pageSource);
    }
    var footerId = cartPageSectionId('main-cart-footer');
    if (footerId) {
      var footerSource = sectionSource(sections[footerId], '#main-cart-footer');
      var footerTarget = document.getElementById('main-cart-footer');
      if (footerSource && footerTarget) footerTarget.replaceWith(footerSource);
    }
  }

  function dispatchUpdate(data) {
    CART_EVENTS.forEach(function (name) {
      try {
        document.dispatchEvent(new root.CustomEvent(name, { detail: { data: data, source: 'gbk98-cart-guard' } }));
      } catch (error) {}
    });
  }

  /* Narrow fetch wrapper: keeps a fresh cart snapshot from every cart response and
     rewrites a theme change/update that would strand an invalid gift (see
     planMutationAugment). Anything unrecognized passes through untouched. */
  var lastCart = null;
  function rememberCart(data) {
    if (data && Array.isArray(data.items)) lastCart = data;
  }
  var nativeFetch = root.fetch.bind(root);
  root.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : String(input && input.url || ''); } catch (error) {}
    var request = null;
    try {
      if (lastCart && init && typeof init.body === 'string' && /\/cart\/(change|update)\.js/.test(url)) {
        var augment = planMutationAugment(lastCart, url, init.body);
        if (augment) {
          var rewritten = {};
          for (var option in init) rewritten[option] = init[option];
          rewritten.method = 'POST';
          rewritten.body = JSON.stringify({
            updates: augment.updates,
            sections: augment.sections,
            sections_url: augment.sections_url
          });
          request = nativeFetch('/cart/update.js?kaching_bundles=true', rewritten);
        }
      }
    } catch (error) { request = null; }
    if (!request) request = nativeFetch(input, init);
    if (/\/cart(\/(change|update|add|clear)\.js|\.js)/.test(url)) {
      request.then(function (response) {
        try { response.clone().json().then(rememberCart, function () {}); } catch (error) {}
      }, function () {});
    }
    return request;
  };

  function run() {
    timer = null;
    if (busy) {
      rerun = true;
      return;
    }
    busy = true;
    reconcileOnce(root.fetch.bind(root), root.location && root.location.pathname || '/cart', sectionList()).then(function (result) {
      retries = 0;
      rememberCart(result.data || result.cart);
      if (result.changed) {
        renderSections(result.data);
        dispatchUpdate(result.data);
      }
      observeCartSurfaces();
    }).catch(function () {
      retries += 1;
      if (retries <= 2) root.setTimeout(function () { schedule(0); }, 700);
    }).then(function () {
      busy = false;
      if (rerun) {
        rerun = false;
        schedule(80);
      }
    });
  }

  function schedule(delay) {
    if (busy) {
      rerun = true;
      return;
    }
    if (timer) root.clearTimeout(timer);
    timer = root.setTimeout(run, typeof delay === 'number' ? delay : 80);
  }

  function mutationTouchesCart(mutation) {
    var target = mutation && mutation.target;
    if (target && target.nodeType === 1 && target.closest && target.closest('#CartDrawer-CartItems, cart-drawer-items, #main-cart-items')) return true;
    return Array.prototype.some.call(mutation && mutation.addedNodes || [], function (node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.matches && node.matches('#CartDrawer-CartItems, cart-drawer-items, #main-cart-items')) return true;
      return !!(node.querySelector && node.querySelector('#CartDrawer-CartItems, cart-drawer-items, #main-cart-items'));
    });
  }

  function observeCartSurfaces() {
    if (!root.MutationObserver) return;
    /* Observe stable roots only: cart-items survives #main-cart-items swaps, so no
       observer is orphaned or re-attached after a repair. */
    ['cart-drawer', 'cart-items'].forEach(function (selector) {
      var surface = document.querySelector(selector);
      if (!surface || surface.__gbk98CartGuardObserved) return;
      surface.__gbk98CartGuardObserved = true;
      var observer = new root.MutationObserver(function (mutations) {
        if (Array.prototype.some.call(mutations || [], mutationTouchesCart)) schedule(80);
      });
      observer.observe(surface, { childList: true, subtree: true });
      observers.push(observer);
    });
  }

  /* Capture-phase interception of the drawer/cart-page remove and minus controls.
     App scripts overwrite window.fetch after this guard loads (last-writer wins), so
     the fetch wrapper alone cannot be relied on. When a click would reduce a paid
     bundle line below its gift threshold, the theme's own request would be rejected
     by the server-side Gift Eligibility Guard (422) and strand the customer; here it
     is replaced with ONE atomic update that also drops the now-invalid gifts, so the
     result stays valid and the gift disappears in the same paint. Clicks on carts
     without exact gift lines are never touched. */
  function offerLineIndexFor(target) {
    if (!target || !target.closest) return null;
    var carrier = target.closest('[data-index]');
    if (!carrier) {
      var quantityHost = target.closest('quantity-input');
      carrier = quantityHost && quantityHost.querySelector ? quantityHost.querySelector('[data-index]') : null;
    }
    var index = carrier ? Number(carrier.getAttribute('data-index')) : NaN;
    if (!isFinite(index) || index < 1) return null;
    return index;
  }

  function interceptCartControls(event) {
    try {
      if (!lastCart || !Array.isArray(lastCart.items)) return;
      if (!lastCart.items.some(isExactGift)) return;
      var target = event.target;
      if (!target || !target.closest) return;
      var removeControl = target.closest('cart-remove-button');
      var minusControl = target.closest('quantity-input button[name="minus"]');
      if (!removeControl && !minusControl) return;
      var control = removeControl || minusControl;
      var index = offerLineIndexFor(control) || offerLineIndexFor(target);
      if (!index) return;
      var line = lastCart.items[index - 1];
      if (!line || !line.key) return;
      var current = quantity(line);
      var nextQuantity = removeControl ? 0 : current - 1;
      if (!removeControl && current <= 1) return; /* theme no-ops a minus at 1 — keep parity */
      var plan = planMutationAugment(lastCart, '/cart/change.js', JSON.stringify({
        line: index,
        quantity: nextQuantity,
        sections: sectionList(),
        sections_url: root.location && root.location.pathname || '/cart'
      }));
      if (!plan) return; /* the change stays valid — let the theme handle it natively */
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      readJson(root.fetch.bind(root), '/cart/update.js?kaching_bundles=true', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: plan.updates,
          sections: plan.sections || sectionList(),
          sections_url: plan.sections_url || (root.location && root.location.pathname) || '/cart'
        })
      }).then(function (data) {
        rememberCart(data);
        renderSections(data);
        dispatchUpdate(data);
      }).catch(function () {
        schedule(0); /* fall back to a fresh reconcile pass */
      });
    } catch (error) {}
  }

  function ready() {
    observeCartSurfaces();
    document.addEventListener('click', interceptCartControls, true);
    CART_EVENTS.forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (event && event.detail && event.detail.source === 'gbk98-cart-guard') return;
        schedule(50);
      });
    });
    schedule(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})(typeof window !== 'undefined' ? window : this);
